import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d934222"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "frisbuy-mobile-review-sheet"
}
const _hoisted_2 = { class: "frisbuy-mobile-review-sheet__header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    width: "40",
    height: "40",
    fill: "white"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M23.3722 26.0335C23.7266 25.6504 23.7269 25.0593 23.3729 24.6759L19.0553 20L23.3729 15.3241C23.7269 14.9407 23.7266 14.3496 23.3722 13.9665L23.2117 13.7931C22.8159 13.3654 22.1396 13.3654 21.7438 13.7931L16.6285 19.3208C16.2738 19.7041 16.2738 20.2959 16.6285 20.6792L21.7438 26.2069C22.1396 26.6346 22.8159 26.6346 23.2117 26.2069L23.3722 26.0335Z",
    fill: "#999999"
  })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "frisbuy-mobile-review-sheet__body" }
const _hoisted_6 = { class: "frisbuy-mobile-review-sheet__author-wrap" }
const _hoisted_7 = { class: "frisbuy-mobile-review-sheet__text" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "frisbuy-mobile-review-sheet__text-prefix" }, "Преимущества: ", -1))
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "frisbuy-mobile-review-sheet__text-prefix" }, "Недостатки: ", -1))
const _hoisted_12 = { key: 2 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "frisbuy-mobile-review-sheet__safe-area",
  "aria-hidden": "true"
}, null, -1))

import { computed } from "vue";
import ReviewAuthor from "./ReviewAuthor.vue";
import PopupReviewMediaList from "./PopupReviewMediaList.vue";
import { imageWithPostId, IMarketplaceReviewsPost } from "../interfaces";


export default /*#__PURE__*/_defineComponent({
  __name: 'MobileReviewSheet',
  props: {
    isOpen: { type: Boolean },
    post: {},
    bestPostIds: {},
    reviewIndex: {},
    reviewDate: {},
    selectedMediaThumbnailUrl: {},
    mediaList: {}
  },
  emits: ["close", "selectMedia"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const currentPostMediaList = computed<imageWithPostId[]>(() => {
  const postId =
    props.post.instagramPost?.frisbuyId || props.post.providerPost?.frisbuyId;

  return props.post.media.map((media) => ({
    ...media,
    postId,
  }));
});

const reviewTitle = computed(() => {
  const postId =
    props.post.instagramPost?.frisbuyId || props.post.providerPost?.frisbuyId;
  const isBestPost = Boolean(
    typeof postId === "number" && props.bestPostIds?.includes(postId)
  );

  return isBestPost ? "Лучший отзыв" : "Отзыв покупателя";
});

function onSelectMedia(media: imageWithPostId) {
  emit("selectMedia", media);
  emit("close");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (props.isOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              class: "frisbuy-mobile-review-sheet__back",
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
            }, _hoisted_4),
            _createElementVNode("span", null, _toDisplayString(reviewTitle.value), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(ReviewAuthor, {
                customerName: 
              props.post.instagramPost.authorUser.fio ||
              `@${props.post.instagramPost.authorUser.username}`
            ,
                avatarColorIndex: props.reviewIndex,
                reviewDate: props.reviewDate,
                rating: props.post.frisbuyPost.rating,
                isSoftStarIcon: false,
                view: "popup"
              }, null, 8, ["customerName", "avatarColorIndex", "reviewDate", "rating"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              (props.post.frisbuyPost.positiveComment)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("span", null, _toDisplayString(props.post.frisbuyPost.positiveComment), 1)
                  ]))
                : _createCommentVNode("", true),
              (props.post.frisbuyPost.negativeComment)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("span", null, _toDisplayString(props.post.frisbuyPost.negativeComment), 1)
                  ]))
                : _createCommentVNode("", true),
              (props.post.frisbuyPost.text)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("span", null, _toDisplayString(props.post.frisbuyPost.text), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(PopupReviewMediaList, {
              mediaList: currentPostMediaList.value,
              selectedMediaThumbnailUrl: props.selectedMediaThumbnailUrl,
              playIconVariant: "mobileSheet",
              onSelectMedia: onSelectMedia
            }, null, 8, ["mediaList", "selectedMediaThumbnailUrl"])
          ]),
          _hoisted_13
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})